// Global edit mode (admins). Editing controls and drafts only show while it is on; it is off by default and remembered on this device.
// window.EditMode.use() returns the current state inside a component; EditMode.set(bool) switches it. Server checks still decide who may edit.
(function () {
  const KEY = 'wb_edit_mode';
  const listeners = new Set();
  let on = false;
  try { on = localStorage.getItem(KEY) === '1'; } catch (e) {}

  const EditMode = {
    get: () => on,
    set(v) {
      on = !!v;
      try { localStorage.setItem(KEY, on ? '1' : '0'); } catch (e) {}
      listeners.forEach(fn => fn(on));
    },
    use() {
      const [v, setV] = React.useState(on);
      React.useEffect(() => { listeners.add(setV); setV(on); return () => { listeners.delete(setV); }; }, []);
      return v;
    }
  };
  window.EditMode = EditMode;
})();
